import { postApi } from 'api/fetchApi'
import { paths } from 'api/generated/password_reset'

type CheckPassword = paths['/users/password/testPassword']

type CheckPasswordMethod = CheckPassword['post']

export type CheckPasswordBody =
  CheckPasswordMethod['parameters']['body']['body']
export type CheckPasswordResponse =
  CheckPasswordMethod['responses']['200']['schema']

export const checkPasswordApi = (password: string) =>
  postApi<CheckPasswordResponse, CheckPasswordBody>(
    '/users/password/testPassword',
    {
      password,
    }
  )
